/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable array-callback-return */
import React, { FunctionComponent } from 'react'

import { Formik, FormikConfig, FormikValues, FormikProps } from 'formik'
import * as Yup from 'yup'

import {
  FormEvaluate,
  IFormControl,
  TFormErrorColor,
  TFormErrors,
} from './FormComponent.types'
import { Container, Wrapper } from './styles'
import { FormikHelpers } from 'formik/dist/types'

export const YupObjectSchema = Yup.object()

export interface IProps extends FormikConfig<FormikValues> {
  validationSchema: (
    validator: typeof Yup,
    formValues: FormikValues,
  ) => {
    [field: string]: any
  }
  children: (formControl: IFormControl) => void
  errorColor?: TFormErrorColor
  onSubmit: (
    formValues: FormikValues,
    formikHelpers?: FormikHelpers<FormikValues>,
  ) => any
  className?: string
  values?: FormikValues
}

export const FormValidator: {
  getErrors: (
    formikProps: FormikProps<FormikValues>,
    formProps: IProps,
  ) => TFormErrors

  isValid: (
    formikProps: FormikProps<FormikValues>,
    formProps: IProps,
  ) => boolean
} = {
  getErrors: (formikProps, formProps) => {
    let errors: TFormErrors = {}

    if (!formikProps || !formProps) {
      return errors
    }

    const { values } = formikProps

    Object?.keys(values)?.map(field => {
      try {
        YupObjectSchema.shape(
          formProps.validationSchema(Yup, formikProps?.values),
        ).validateSyncAt(field, values)
      } catch (error: any) {
        const touched = formikProps?.touched[field]
        const value = formikProps?.values[field]

        if (
          !touched ||
          (typeof value === 'string' && value.trim() === '') ||
          (typeof value === 'number' && isNaN(value)) ||
          value === 0
        ) {
          return
        }

        errors = {
          ...errors,
          [field]: {
            value: error?.value[error?.path],
            message: error?.message,
          },
        }
      }
    })

    return errors
  },

  isValid: (formikProps, formProps) => {
    if (!formikProps || !formProps) {
      return false
    }

    try {
      YupObjectSchema.shape(
        formProps.validationSchema(Yup, formikProps?.values),
      ).validateSync(formikProps?.values)

      return true
    } catch {
      return false
    }
  },
}

const FormComponent: FunctionComponent<IProps> = ({
  errorColor,
  className,
  ...props
}) => (
  <Container className={className}>
    <Formik
      {...props}
      validationSchema={YupObjectSchema.shape({})}
      // validate={() => {}}
      validateOnBlur={false}
      validateOnChange={false}
      validateOnMount={false}
    >
      {(formikProps: FormikProps<FormikValues>) => (
        <Wrapper>
          {props.children({
            ...formikProps,
            enableReinitialize: props.enableReinitialize,
            isValid: FormValidator.isValid(formikProps, props),
            handleSubmit: () =>
              props.onSubmit(formikProps?.values, formikProps),
            errors: FormValidator.getErrors(formikProps, props),
            errorColor,
          })}

          {FormEvaluate.void()}
        </Wrapper>
      )}
    </Formik>
  </Container>
)

FormComponent.defaultProps = {
  errorColor: 'red',
  // onSubmit: () => {},
  initialValues: {},
}

export default FormComponent
